module.exports = __webpack_public_path__ + "img/oufu_92x120_8x12_5.prt.984089f5.jpg";